<app-processing [visible]="!pageVars.isReady"></app-processing>
<app-unsaved-changes-dialog [(visible)]="pageVars.showUnsavedChangesDialog" (decision)="onDialogConfirm($event)"> </app-unsaved-changes-dialog>

<div class="flex justify-content-center">
  <p-card>
    <ng-template pTemplate="header">
      <p-breadcrumb [model]="pageVars.breadcrumbItems">
        <ng-template let-item let-last="last" let-first="first" pTemplate="item">
          <ng-container *ngIf="!first">
            <a *ngIf="item.routerLink" [routerLink]="item.routerLink">{{ item.label }}</a>
            <div *ngIf="!item.routerLink" class="breadcrumb-current-item">
              {{ item.label }}
            </div>
          </ng-container>
        </ng-template>
      </p-breadcrumb>
    </ng-template>
    <p-treetable [value]="nodes" [scrollable]="true" dataKey="key" [tableStyle]="{ 'min-width': '50rem', 'width': '50vw' }">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 2rem"></th>
          <th>Name</th>
          <th>Location Type</th>
          <th>Containment Type</th>
          <th class="flex justify-content-center">
            <p-button
              class="mr-3 mt-3"
              label="New"
              [raised]="true"
              icon="fa fa-plus"
              size="small"
              (click)="gridNewRow()"
              [disabled]="pageVars.isEditing">
            </p-button>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-rowIndex="ri">
        <tr [ttRow]="rowNode">
          <td style="width: 4rem; font-size: x-small">
            <button
              pButton
              pRipple
              type="button"
              icon="fa fa-plus"
              (click)="gridNewChild(rowData)"
              text
              rounded
              severity="secondary"
              [title]="'Add a child to ' + rowData.name"
              [outlined]="true"
              [disabled]="pageVars.isEditing"
              style="font-size: x-small"></button>
          </td>
          <td>
            <p-treeTableToggler [rowNode]="rowNode" />
            {{ rowData.name }}
          </td>
          <td>
            {{ rowData.locationType?.name ?? rowData.locationType?.text ?? 'Unknown' }}
          </td>
          <td>
            {{ rowData.containmentType?.name ?? rowData.containmentType.text ?? 'Unknown' }}
          </td>
          <td class="flex justify-content-center">
            <button
              pButton
              pRipple
              type="button"
              icon="fa fa-pencil"
              (click)="gridRowEditInit(rowData)"
              text
              rounded
              severity="secondary"
              [title]="'Edit ' + rowData.locationType?.name"
              [disabled]="pageVars.isEditing"
              [outlined]="true"></button>
            <button
              *ngIf="rowData.locationType?.name == 'Site'"
              pButton
              pRipple
              type="button"
              icon="fa fa-book-open"
              (click)="navigateToCatalog(rowData.id)"
              text
              rounded
              severity="secondary"
              title="Site Catalog"
              [disabled]="pageVars.isEditing"
              [outlined]="true"></button>
          </td>
        </tr>
      </ng-template>
    </p-treetable>
  </p-card>
</div>

<p-dialog
  [header]="dialogVars.title"
  [modal]="true"
  [showHeader]="false"
  [position]="'center'"
  [closable]="false"
  [closeOnEscape]="false"
  [(visible)]="dialogVars.visible"
  [style]="{ 'min-width': '40rem', 'width': '40vw' }"
  appendTo="body">
  <div>
    <p-fieldset legend="Location Details">
      <div class="grid">
        <div class="col-4">
          <p-floatlabel class="mt-1" variant="on">
            <label for="name">Name</label>
            <input pInputText id="name" class="w-full" autocomplete="off" [(ngModel)]="dialogVars.data.name" data-testid="locationName" />
          </p-floatlabel>
        </div>
        <div class="col-4">
          <p-floatlabel class="mt-1 w-full" variant="on">
            <p-select
              inputId="locationType"
              [(ngModel)]="dialogVars.data.locationTypeId"
              [options]="locationTypesList()"
              optionLabel="text"
              optionValue="id"
              styleClass="w-full"
              data-testId="locationType"
              size="small"
              appendTo="body"
              [disabled]="locationTypesDisabled()"></p-select>
            <label for="locationType">Location Type</label>
          </p-floatlabel>
        </div>
        <div class="col-4">
          <p-floatlabel class="mt-1 w-full" variant="on">
            <p-select
              [(ngModel)]="dialogVars.data.containmentTypeId"
              inputId="containmentType"
              [options]="containmentTypes"
              optionLabel="text"
              optionValue="id"
              styleClass="w-full"
              data-testId="containmentType"
              size="small"
              appendTo="body">
            </p-select>
            <label for="containmentType">Containment Type</label>
          </p-floatlabel>
        </div>
      </div>
      <div class="grid mt-1">
        <div class="col-12">
          <p-floatlabel variant="on" class="w-full">
            <p-treeselect
              inputId="parentId"
              size="small"
              [(ngModel)]="dialogVars.parent"
              [options]="nodes"
              class="w-full"
              containerStyleClass="w-full"
              showClear="true"
              appendTo="body"></p-treeselect>
            <label for="parentId">Parent</label>
          </p-floatlabel>
        </div>
      </div>
      <div class="grid mt-1">
        <div class="col-4 flex gap-2">
          <label for="isSelectable">Selectable</label>
          <p-toggleswitch id="isSelectable" [(ngModel)]="dialogVars.data.isSelectable" />
        </div>
        <div class="col-4 flex gap-2">
          <label for="isActive">Active</label>
          <p-toggleswitch id="isActive" [(ngModel)]="dialogVars.data.isActive" />
        </div>
      </div>
    </p-fieldset>
    <p-fieldset *ngIf="dialogVars.visible" legend="Address Details">
      <div class="grid">
        <div class="col-4 flex align-items-middle gap-2">
          <label for="isPrivate">Private</label>
          <p-toggleswitch id="isPrivate" [(ngModel)]="dialogVars.data.address.isPrivate" />
        </div>
        <div class="col-8">
          <p-floatlabel variant="on">
            <p-select
              styleClass="w-full"
              inputId="privateUserId"
              appendTo="body"
              [(ngModel)]="dialogVars.data.address.privateUserId"
              [disabled]="!dialogVars.data.address.isPrivate"
              size="small"></p-select>
            <label for="privateUserId">Private User</label>
          </p-floatlabel>
        </div>
      </div>
      <div class="grid mt-1">
        <div class="col-12">
          <p-floatlabel variant="on">
            <textarea id="streets" rows="3" [(ngModel)]="dialogVars.streets" pTextarea style="width: 100%"></textarea>
            <label for="streets">Streets</label>
          </p-floatlabel>
        </div>
      </div>
      <div class="grid">
        <div class="col-12">
          <p-floatlabel variant="on">
            <input id="city" type="text" pInputText [(ngModel)]="dialogVars.data.address.city" class="w-full" data-testId="city" />
            <label for="city">City</label>
          </p-floatlabel>
        </div>
      </div>
      <div class="grid mt-1">
        <div class="col-4">
          <p-floatlabel variant="on">
            <p-select
              inputId="stateCode"
              [(ngModel)]="dialogVars.data.address.stateCode"
              [options]="dialogStateList()"
              optionLabel="text"
              optionValue="id"
              [showClear]="true"
              class="w-full"
              data-testId="stateCode"
              size="small"
              appendTo="body"></p-select>
            <label for="stateCode">State</label>
          </p-floatlabel>
        </div>
        <div class="col-3">
          <p-floatlabel variant="on">
            <input id="postalCode" type="text" pInputText [(ngModel)]="dialogVars.data.address.postalCode" class="w-full" data-testId="postalCode" />
            <label for="city">Postal Code</label>
          </p-floatlabel>
        </div>
        <div class="col-5">
          <p-floatlabel variant="on">
            <p-select
              inputId="countryCoode"
              [(ngModel)]="dialogVars.data.address.countryCode"
              [options]="countries"
              optionLabel="text"
              optionValue="id"
              [showClear]="true"
              data-testId="countryCoode"
              class="w-full"
              size="small"
              appendTo="body"></p-select>
            <label for="countryCoode">Country</label>
          </p-floatlabel>
        </div>
      </div>
    </p-fieldset>
  </div>
  <ng-template #footer>
    <div class="border-top-1 surface-border pt-2 flex justify-content-between w-full">
      <p-button label="Cancel" icon="fa fa-times" severity="danger" size="small" [raised]="true" (click)="gridRowEditCancel()" />
      <p-button
        label="Save"
        icon="fa fa-check"
        severity="success"
        size="small"
        [raised]="true"
        (click)="gridRowEditSave()"
        [disabled]="!dialogIsValid()" />
    </div>
  </ng-template>
</p-dialog>
